import React, { useEffect } from 'react';
import AnswerButton from '../../Buttons/AnswerButton';
import { useCounter } from '../../../Handler/CounterHandler';
import useDocTitle from '../../../Handler/DocTitleHandler';
import Text from '../../Text';

/**
 * Arthur-Fischer-Erfinderpreis Quick Check App
 *
 * Step D
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const StepSchutzrecht = () => {
  const { setDocTitle } = useDocTitle();
  const { counterCurrent, counterTotal } = useCounter();

  // Changes the doc title
  useEffect(() => {
    setDocTitle(`Schritt ${counterCurrent}/${counterTotal}`);
  }, [counterCurrent]);

  return (<>
    <div className="text text--small text--afp-quickcheck text--counter">{counterCurrent} / {counterTotal}</div>

    <h2 className="headline headline--2">Schutzrecht</h2>

    <div className="text text--afp-quickcheck">
      Was trifft auf Sie zu?
    </div>

    <div className="container__afp-quickcheck-answers">
      <AnswerButton answer={true}>Patentanmeldung<sup>*</sup></AnswerButton>
      <AnswerButton answer={true}>Gebrauchsmuster<sup>**</sup></AnswerButton>
      <AnswerButton answer={false} nextStep={'result'}>Keines von beiden</AnswerButton>
    </div>

    <div className="text text--afp-quickcheck text--small">
      <sup>*</sup> <Text path="steps.privateHinweise.textSchutzrecht01">Ich habe nach dem 31.12.2019 ein Patent beim Deutschen Patent- und Markenamt,
      beim Europäischen Patentamt oder der Weltorganisation für geistiges Eigentum angemeldet und
      erteilt bekommen oder kann den ersten Prüfungsbescheid bzw. den amtlichen Recherchebericht mit
      den darin aufgeführten Druckschriften vorlegen.</Text>
    </div>

    <div className="text text--afp-quickcheck text--small">
      <sup>**</sup> <Text path="steps.privateHinweise.textSchutzrecht02">Ich habe nach dem 31.12.2019 ein Gebrauchsmuster beim Deutschen Patent- und
      Markenamt angemeldet und kann einen amtlichen Recherchebericht mit den darin aufgeführten
      Druckschriften vorlegen.</Text>
    </div>

    <div className="text text--afp-quickcheck text--small">
      <Text path="steps.privateHinweise.textSchutzrecht03">Hinweis: Die Patente und Gebrauchsmuster müssen in Kraft bzw. Patentanmeldungen anhängig sein.</Text>
    </div>
  </>);
}

export default StepSchutzrecht;

